﻿
export enum ToastType {
    Success = 'success',
    Info = 'info'
}

export interface ToastDef {
    message: string;
    type: ToastType;
}

function createElementFromHTML(htmlString): HTMLElement {
    var div = document.createElement('div');
    div.innerHTML = htmlString.trim();

    // Change this to div.childNodes to support multiple top-level nodes.
    return div.firstChild as HTMLElement;
}

const htmlDivContainer =
    `
    <div id="toast-container" class="position-fixed top-0 start-50 translate-middle-x p-3" style="z-index: 11;width: 90%; max-width: 90%;">
    </div>
    `;

export class Toaster {
    
    private getContainer(): HTMLElement {
        let el = document.getElementById("toast-container");
        if (!el) {
            el = createElementFromHTML(htmlDivContainer);            
            el = document.body.appendChild(el);
        }
        return el;
    }

    private createToastHtml(toastDef: ToastDef): string {
        //<button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
        //style="width: 80%;"
        const html =
        `
        <div class="toast align-items-center py-2" role="alert" aria-live="assertive" aria-atomic="true" style="width: 100%; max-width: 100%;">
          <div class="d-flex">
            <div class="toast-body fs-4 d-none d-md-block">
                <i class="far fa-check-circle fa-2x text-success" style="vertical-align: middle;"></i>
                <span class="p-2 text-black">${toastDef.message}</span>
            </div>            
            <div class="toast-body fs-6 d-block d-sm-block d-md-none">
                <i class="far fa-check-circle fa-2x text-success" style="vertical-align: middle;"></i>
                <span class="p-2 text-black">${toastDef.message}</span>
            </div>
          </div>
        </div>
        `;
        return html;
    }
    
    public show(toastDef: ToastDef): void {                
        const htmlDivToast = this.createToastHtml(toastDef);

        const el = createElementFromHTML(htmlDivToast);
        const container = this.getContainer();
        container.appendChild(el);
        //@ts-ignore
        const toast = new bootstrap.Toast(el, {
            animation: true,
            autohide: true,
            delay: 3000
        });
        el.addEventListener('hidden.bs.toast', function () {
            toast.dispose();
            container.removeChild(el);
        });
        toast.show();    
    }
}